export default __webpack_public_path__ + "static/media/Comp 2_00005.60fa13d1.png";